import styled from 'styled-components';
import {
  DEFAULT_MOBILE_PADDING,
  BREAKPOINT_SMALL,
  DEFAULT_DESKTOP_PADDING,
  BREAKPOINT_MEDIUM,
  MarketingSection,
} from 'components/MarketingPagesShared/styles';

export const SwitchPageQuotesContainer = styled(MarketingSection)`
  && {
    padding-bottom: ${DEFAULT_DESKTOP_PADDING}px;

    @media (max-width: ${BREAKPOINT_SMALL}px) {
      padding-bottom: ${DEFAULT_MOBILE_PADDING}px;
    }
  }
`;

export const SwitchQuotesTitle = styled.h1`
  width: 90%;
  margin: 60px 0;
  font-weight: 800;
  font-size: 4rem;
  line-height: 1.2;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    width: auto;
    font-size: 2.5rem;
  }
`;

export const SwitchQuotesColumns = styled.div`
  display: grid;
  grid-column-gap: ${DEFAULT_MOBILE_PADDING}px;
  grid-template-columns: repeat(3, 1fr);
  color: white;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    grid-column-gap: 0;
    margin: 0 -${DEFAULT_MOBILE_PADDING}px;
    overflow: auto;
    scroll-snap-type: x mandatory;
    scroll-snap-align: center;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const SwitchQuote = styled.blockquote`
  padding: 0;
  border: 0;
  font-size: 1.5rem;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    font-size: 1.25rem;
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    width: 90vw;
    /**
     * This is a little tricky. Basically on mobile, we have a situation like
     * this:
     * +---------------------+        +----------------------+
     * |                     |        |                      |
     * +--+  +---------+  +--+        +----+  +-----------+  |
     * |  |  |         |  |  | scroll |    |  |           |  |
     * |  |  |         |  |  | +----> |    |  |           |  |
     * |  |  |         |  |  |        |    |  |           |  |
     * +--+  +---------+  +--+        +----+  +-----------+  |
     * |                     |        |                      |
     * +---------------------+        +----------------------+
     *
     * So we want some padding on the sides, but we also want the distance
     * between the cells to be correct. So, we add padding that will appear
     * correctly on the sides, and then shift the appropriate cells slightly to
     * make the space between the elements correct 
     */
    padding: 0 ${DEFAULT_MOBILE_PADDING}px;
    font-size: 1.125rem;
    scroll-snap-align: center;

    &:not(:first-of-type) {
      margin-left: -${DEFAULT_MOBILE_PADDING}px;
    }
  }
`;

export const SwitchQuoteText = styled.p`
  color: white;
`;

export const SwitchQuoteAuthor = styled.cite`
  display: block;
  margin-top: 40px;
  font-size: 85%;
  font-style: normal;
  line-height: 1.4;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    margin-top: 20px;
  }
`;

export const SwitchQuotePodcast = styled.div`
  margin-top: 5px;
  margin-bottom: 32px;
  font-weight: bold;
  text-transform: uppercase;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    margin-bottom: 20px;
  }
`;
